import { goToKeys, ShortcutKeys, shortcutKeys } from "@nexxt/app-kit";
import { Dialog } from "@nexxt/ui";
import { m } from "../../paraglide/messages.js";
import { type NavItem, sectionLabel } from "./navigation";

// `?` (design-system.md §4.10): every shortcut of the app, the places from the same list as the sidebar, so a new
// place with a key shows up here by itself (ADR-114).

interface ShortcutsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  places: NavItem[];
}

export function ShortcutsDialog({ open, onOpenChange, places }: ShortcutsDialogProps) {
  const general = [
    { id: "palette", keys: shortcutKeys.palette, label: m.shortcut_palette() },
    { id: "search", keys: shortcutKeys.search, label: m.shortcut_search() },
    { id: "sidebar", keys: shortcutKeys.rail, label: m.shortcut_sidebar() },
    { id: "help", keys: shortcutKeys.help, label: m.shortcut_help() },
    { id: "undo", keys: shortcutKeys.undo, label: m.shortcut_undo() },
  ];
  const goTo = places.flatMap((place) =>
    place.key
      ? [
          {
            id: place.id,
            keys: goToKeys(place.key),
            label: [sectionLabel(place), place.label()].filter(Boolean).join(" › "),
          },
        ]
      : [],
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title={m.shortcuts_title()}>
      <div className="space-y-4">
        <ShortcutList title={m.shortcuts_general()} rows={general} />
        <ShortcutList title={m.palette_go_to()} rows={goTo} />
      </div>
    </Dialog>
  );
}

function ShortcutList({
  title,
  rows,
}: {
  title: string;
  rows: { id: string; keys: readonly string[]; label: string }[];
}) {
  return (
    <section className="space-y-1.5">
      <h3 className="text-xs font-medium text-muted-foreground">{title}</h3>
      <dl className="divide-y divide-border">
        {rows.map((row) => (
          <div key={row.id} className="flex items-center justify-between gap-4 py-1.5 text-sm">
            <dt>{row.label}</dt>
            <dd>
              <ShortcutKeys keys={row.keys} />
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
